export enum LocalStorageKey {
  FileEmailConversationSetting = 'fileEmailConversation',
  SubmittalsView = 'submittalsView',
  RfisView = 'rfisView',
  Protractor = 'PROTRACTOR_ENV',
  SearchBarVisibility = 'searchBarVisibility',
  SideBarMode = 'sideBarMode'
}
